import { render, staticRenderFns } from "./dashboard-bar-echarts.vue?vue&type=template&id=5c2dc660&"
import script from "./dashboard-bar-echarts.vue?vue&type=script&lang=js&"
export * from "./dashboard-bar-echarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports